import { IsNotEmpty, IsUUID } from 'class-validator';

export class MatchManualDto {
  @IsUUID('4', { message: 'movimiento_propio_id inválido' })
  @IsNotEmpty()
  movimiento_propio_id: string;

  @IsUUID('4', { message: 'movimiento_banco_id inválido' })
  @IsNotEmpty()
  movimiento_banco_id: string;
}
